var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echartRiver"},[(_vm.riverLegendList.length > 0)?_c('div',{attrs:{"id":"riverEcharts"}}):_vm._e(),(_vm.riverLegendList.length == 0 && _vm.riverLoading == false)?_c('div',[_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("抱歉，该企业暂无数据")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }